import React, { createContext, useContext } from 'react';

import type { PointsSummary } from '@/types';

export interface PointsSummaryRefreshOptions {
  silent?: boolean;
}

interface PointsSummaryContextValue {
  summary: PointsSummary | null;
  loading: boolean;
  error: string | null;
  display: string;
  title: string;
  refresh: (options?: PointsSummaryRefreshOptions) => Promise<void>;
  openCenter: () => void;
}

const PointsSummaryContext = createContext<PointsSummaryContextValue | undefined>(undefined);

interface PointsSummaryProviderProps {
  value: PointsSummaryContextValue;
  children: React.ReactNode;
}

export const PointsSummaryProvider: React.FC<PointsSummaryProviderProps> = ({
  value,
  children,
}) => {
  return <PointsSummaryContext.Provider value={value}>{children}</PointsSummaryContext.Provider>;
};

export const usePointsSummary = (): PointsSummaryContextValue => {
  const context = useContext(PointsSummaryContext);
  if (!context) {
    throw new Error('usePointsSummary must be used within PointsSummaryProvider');
  }
  return context;
};
